import { FormattedMessage } from "react-intl"

import { Tag } from "@/components/Tag"
import { SHARED_DATA_STATUS, type SHARED_DATA_STATUS_VALUE } from "@/domain/sharedData/constants"
import type { TagProps } from "@chakra-ui/react"

type Props = {
  status?: SHARED_DATA_STATUS_VALUE | string
} & TagProps

// Design system status (dot + word, ADR 0001, Q5): filled = settled, hollow = pending, muted =
// closed. Never a tinted background. Red is kept for "action required" (ADR 0009, D3): pending is
// no longer red.
const statusDisplay: Record<string, { variant: TagProps["variant"]; messageId: string }> = {
  [SHARED_DATA_STATUS.COMPLETED]: { variant: "status", messageId: "userSharedData.status.ended" },
  [SHARED_DATA_STATUS.ACCEPTED]: { variant: "status", messageId: "userSharedData.status.accepted" },
  [SHARED_DATA_STATUS.CANCELLED]: {
    variant: "statusMuted",
    messageId: "userSharedData.status.cancelled",
  },
  [SHARED_DATA_STATUS.CLOSED]: {
    variant: "statusMuted",
    messageId: "userSharedData.status.closed",
  },
  [SHARED_DATA_STATUS.DENIED]: {
    variant: "statusMuted",
    messageId: "userSharedData.status.denied",
  },
  [SHARED_DATA_STATUS.REVOKED]: {
    variant: "statusMuted",
    messageId: "userSharedData.status.revoked",
  },
  [SHARED_DATA_STATUS.ARCHIVE]: {
    variant: "statusMuted",
    messageId: "userSharedData.status.archived",
  },
}

const askedDisplay = { variant: "statusOpen", messageId: "userSharedData.status.asked" }

export const getSharedDataStatusDisplay = (status?: string) =>
  (status && statusDisplay[status]) || askedDisplay

export const SharedDataStatusTag: React.FC<Props> = ({ status, ...props }) => {
  const { variant, messageId } = getSharedDataStatusDisplay(status)

  return (
    <Tag variant={variant} {...props}>
      <FormattedMessage id={messageId} />
    </Tag>
  )
}
